export const LANGUAGE_MAP = {
  en: {
    // Header and Controls
    languageEn: "EN(US)",
    languageHi: "HI(IN)",
    mute: "Mute",
    unmute: "Unmute",
    
    // Success State
    closingIn: "Closing in",
    seconds: "Secs...",
    secureAndEncrypted: "Secure and encrypted with",
    
    // Main Content
    verifyAadhaar: "Let's verify your Aadhaar",
    verifyAadhaarDescription: "You'll be redirected to DigiLocker to verify your Aadhaar securely.",
    securedByGovt: "Secured by Govt. of India",
    continue: "Continue",
    
    // Mobile Content
    mobileTitle: "Verify Your Aadhaar Securely",
    mobileDescription: "Link your Aadhaar instantly using DigiLocker – a secure government-approved platform. This helps us verify your identity quickly and keep your account safe.",
    mobileDisclaimer: "We will never store your Aadhaar number. Verification is done securely via DigiLocker",
    startAadhaarVerification: "Start Aadhaar Verification",
    
    // Desktop Content
    desktopTitle: "Verify Your Aadhaar with DigiLocker",
    desktopSubtitle: "Secure. Fast. Government-approved.",
    desktopDescription: "To complete your verification, we'll redirect you to DigiLocker, the official digital document platform from the Government of India. Your Aadhaar will be verified in just a couple of minutes — no physical paperwork required.",
    desktopDisclaimer: "We do not store your Aadhaar number. Verification happens entirely through DigiLocker.",
    
    // Button States
    loading: "Loading...",
    error: "An error occurred. Please try again.",
    
    // Accessibility
    successGifAlt: "Success Animation",
    idtoLogoAlt: "IDTO Logo",
    digilockerLogoAlt: "DigiLocker Logo"
  },
  
  hi: {
    // Header and Controls
    languageEn: "EN(US)",
    languageHi: "HI(IN)",
    mute: "मौन",
    unmute: "मौन हटाएं",
    
    // Success State
    closingIn: "बंद हो रहा है",
    seconds: "सेकंड में...",
    secureAndEncrypted: "सुरक्षित और एन्क्रिप्टेड",
    
    // Main Content
    verifyAadhaar: "आइए आपका आधार सत्यापित करें",
    verifyAadhaarDescription: "आपको आधार सुरक्षित रूप से सत्यापित करने के लिए डिजीलॉकर पर पुनर्निर्देशित किया जाएगा।",
    securedByGovt: "भारत सरकार द्वारा सुरक्षित",
    continue: "जारी रखें",
    
    // Mobile Content
    mobileTitle: "अपना आधार सुरक्षित रूप से सत्यापित करें",
    mobileDescription: "डिजीलॉकर का उपयोग करके तुरंत अपना आधार लिंक करें – एक सुरक्षित सरकार-अनुमोदित प्लेटफॉर्म। यह हमें आपकी पहचान जल्दी सत्यापित करने और आपका खाता सुरक्षित रखने में मदद करता है।",
    mobileDisclaimer: "हम कभी भी आपका आधार नंबर संग्रहित नहीं करेंगे। सत्यापन डिजीलॉकर के माध्यम से सुरक्षित रूप से किया जाता है",
    startAadhaarVerification: "आधार सत्यापन शुरू करें",
    
    // Desktop Content
    desktopTitle: "डिजीलॉकर के साथ अपना आधार सत्यापित करें",
    desktopSubtitle: "सुरक्षित। तेज़। सरकार-अनुमोदित।",
    desktopDescription: "आपका सत्यापन पूरा करने के लिए, हम आपको डिजीलॉकर पर पुनर्निर्देशित करेंगे, भारत सरकार का आधिकारिक डिजिटल दस्तावेज़ प्लेटफॉर्म। आपका आधार कुछ ही मिनटों में सत्यापित हो जाएगा — कोई भौतिक कागजी कार्य आवश्यक नहीं।",
    desktopDisclaimer: "हम आपका आधार नंबर संग्रहित नहीं करते। सत्यापन पूरी तरह से डिजीलॉकर के माध्यम से होता है।",
    
    // Button States
    loading: "लोड हो रहा है...",
    error: "एक त्रुटि हुई। कृपया पुनः प्रयास करें।",
    
    // Accessibility
    successGifAlt: "सफलता एनीमेशन",
    idtoLogoAlt: "आईडीटीओ लोगो",
    digilockerLogoAlt: "डिजीलॉकर लोगो"
  }
};

export type LanguageCode = 'en' | 'hi';
export type LanguageKey = keyof typeof LANGUAGE_MAP.en;

export const getText = (language: LanguageCode, key: LanguageKey): string => {
  return LANGUAGE_MAP[language][key];
};
